import { useOrderModel } from './useOrderModel'

export function useOrderListModel() {
  const { list } = useOrderModel()

  return list
}
